module.exports = __webpack_public_path__ + "static/media/dod.8bf685b7.svg";